import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";

const DropDown = ({
  icon,
  anchorRef,
  handleToggle,
  open,
  handleClose,
  children,
  disabled,
  style,
  popperStyle = {},
}) => {
  return (
    <div>
      <div
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        style={{ cursor: disabled ? "not-allowed" : "pointer", ...style }}
      >
        {icon}
      </div>
      <Popper
        style={{ zIndex: 99, ...popperStyle }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper style={{ boxShadow: "0 0 15px rgba(0,0,0,0.14)" }}>
              <ClickAwayListener onClickAway={handleClose}>
                {children}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default DropDown;
